const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

const CustomErrorMessage = props => {
    const { errorState, errorMessage, type } = props;
    let error = null;

    if (errorState) {
        const message = type ?
        (
            <OKMessage type={type === 'error' ? 'warning' : type}>
                {errorMessage}
            </OKMessage>
        ) :
        (
            <span className="ok-input__message">
                {errorMessage}
            </span>
        );

        error = (
            <div className="ok-input--error">
                {message}
            </div>
        );
    }

    return error;
};

CustomErrorMessage.propTypes = {
    errorState: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    type: PropTypes.string
};

module.exports = CustomErrorMessage;